import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'heading',
    label: 'Heading',
    type: types.TEXT
  },
  {
    key: 'container_settings',
    label: 'Container Settings',
    type: types.OBJECT,
    children: [
      {
        key: 'background_color',
        label: 'Background Color',
        type: types.TEXT
      },
      {
        key: 'text_color',
        label: 'Text Color',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'card_settings',
    label: 'Card Settings',
    type: types.OBJECT,
    children: [
      {
        key: 'container_background_color',
        label: 'Container Background Color',
        type: types.TEXT
      },
      {
        key: 'card_background_color',
        label: 'Card Background Color',
        type: types.TEXT
      },
      {
        key: 'card_text_color',
        label: 'Card Text Color',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'gallery',
    label: 'Gallery',
    type: types.ARRAY,
    children: [
      {
        key: 'name',
        label: 'Gallery Name',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Short Description',
        type: types.TEXT
      },
      {
        key: 'image',
        label: 'Preview Image URL',
        type: types.TEXT
      },
      {
        key: 'url',
        label: 'Target Gallery URL',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  heading: 'Gallery',
  container_settings: {
    background_color: '#ffffff',
    text_color: '#000000'
  },
  card_settings: {
    container_background_color: '#ffffff',
    card_background_color: '#ffffff',
    card_text_color: '#000000'
  },
  gallery: [
    {
      name: 'FF-91 Gallery',
      description: 'Preview images of the FF-91',
      image: 'https://ff-genesis-cdn.s3.amazonaws.com/faraday-future-gallery/ff-91/ff-91-gallery25.png',
      url: '/us/gallery/ff-91/'
    },
    {
      name: 'FF-91 Gallery',
      description: 'Preview images of the FF-91',
      image: 'https://ff-genesis-cdn.s3.amazonaws.com/faraday-future-gallery/ff-91/ff-91-gallery25.png',
      url: '/us/gallery/ff-91/'
    },
    {
      name: 'FF-91 Gallery',
      description: 'Preview images of the FF-91',
      image: 'https://ff-genesis-cdn.s3.amazonaws.com/faraday-future-gallery/ff-91/ff-91-gallery25.png',
      url: '/us/gallery/ff-91/'
    }
  ]
};

export default {
  title: 'Gallery Index',
  id: 'GalleryIndex',
  propsSchema,
  defaultProps
};
